import {mock} from './index';

export default {
  getAppMenuGroupList: () => mock('/admin/app/menuGroup/list'),
  getAppMenuGroupAssignList: () => mock('/admin/app/menuGroup/menu/assignedList'),
  createAppMenuGroup: () => mock('/admin/app/menuGroup/create'),
  modifyAppMenuGroup: () => mock('/admin/app/menuGroup/modify'),
  deleteAppMenuGroup: () => mock('/admin/app/menuGroup/delete'),
  getAppMenuGroupMenuList: () => mock('/admin/app/menuGroup/menu/list'),
  assignMenuGroupMenu: () => mock('/admin/app/menuGroup/menu/assign')
};
